<template>
    <div class="local">
        <div class="map">
            <div class="map__item">
                <h2 class="map__item__title">Matriz</h2>
                <div class="tel"><img class="tel__img" src="@/assets/icons/tel.svg" alt=""><span>(43) 3276-0006</span></div>
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14643.20363603207!2d-51.4233112!3d-23.431558!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xeebbc9b876e1c14c!2sFibrillare%20M%C3%B3veis%20de%20Alum%C3%ADnio%20e%20Fibra%20Sint%C3%A9tica!5e0!3m2!1spt-BR!2sbr!4v1570711824501!5m2!1spt-BR!2sbr"
                        width="600" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
            </div>
            <div class="map__item">
                <h2 class="map__item__title">Loja</h2>
                <div class="tel"><img class="tel__img" src="@/assets/icons/tel.svg" alt=""><span>(44) 3029-6003</span></div>
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14644.334516194898!2d-51.942962!3d-23.421346!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xde74cd2059a23584!2sFibrillare!5e0!3m2!1spt-BR!2sbr!4v1570711969455!5m2!1spt-BR!2sbr"
                        width="600" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Local"
    }
</script>

<style lang="scss" scoped>
    .map {
        max-width: 1280px;
        margin: 0 auto;
        padding: 0 15px;
        display: flex;
        justify-content: space-between;

        &__item {
            margin: 0 15px;

            &__title {
                text-align: center;
                font-size: 2rem;
                font-weight: 400;
            }
        }
    }

    .tel {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px auto 40px auto;

        span {
            font-family: HelveticaNeue, Arial, sans-serif;
        }
    }

    .tel__img {
        width: 28px;
        margin-right: 10px;
    }

    @media only screen and (max-width: 1279px) {
        .map {
            flex-wrap: wrap;
            justify-content: center;
        }

        iframe {
            width: 720px;
            margin-bottom: 80px;
        }
    }

    @media only screen and (max-width: 767px) {
        iframe {
            width: 300px;
            margin-bottom: 40px;
        }
    }


</style>